export default {
  row1: [
    {
      column: "column1",
      rows: {
        row1: [
          {
            name: "remarks",
            label: "Remark",
            component: "text-field",
            width: "50%",
          },
          {
            name: "handledBy",
            label: "Handled By", 
            component: "dropdown",
            width: "50%",
          },
        ],
        row2: [
          {
            name: "filePath",
            component: "fileselector",
          },
        ],
      },
    },
  ],
};
